export default __webpack_public_path__ + "da89c4b4c1c21d93d2ee3e46ce00bc3e.svg";